/**
 * CancelBattleSettings use case: returns to "map" scene and resets draft settings.
 */

import type { RenderPort } from "../ports.js";
import type { StageSettings } from "../../domain/stage-settings.js";
import { createDefaultStageSettings } from "../../domain/stage-settings.js";
import type { AppState } from "../types.js";
import type { MageProfile } from "../../domain/mage-profile.js";
import { mapStateToView } from "../state-view.js";

export interface CancelBattleSettingsDeps {
  render: RenderPort;
  setDraftSettings(settings: StageSettings): void;
  setPendingFieldId(fieldId: string | null): void;
  getState(): Pick<AppState, "scene" | "mapProgress" | "selectedFieldId">;
  getMageProfile?(): MageProfile;
}

export function createCancelBattleSettings(deps: CancelBattleSettingsDeps) {
  return function cancelBattleSettings(): void {
    deps.setDraftSettings(createDefaultStageSettings());
    deps.setPendingFieldId(null);
    const state = deps.getState();
    const mapState: AppState = { ...state, scene: "map" };
    const mageProfile = deps.getMageProfile?.();
    deps.render.setScene("map");
    deps.render.update(mapStateToView(mapState, mageProfile));
  };
}
